/** @jsx jsx */

import { jsx } from '@balance-web/core';
import { getDecorativeSurfaces, useTheme } from '@balance-web/theme';

import { Base } from './Base';
import type { AvatarSizeType } from './types';
import { getKeyFromText, useInitials } from './utils';

export type UserAvatarProps = {
  /** Does not support css. */
  css?: never;
  /** @deprecated use "inactive" prop. */
  disabled?: boolean;
  /** Signal to the user that this avatar is in some way not available. */
  inactive?: boolean;
  /** Signal to the user that this avatar is less significant e.g "guest user"  */
  guest?: boolean;
  /** The name of the person represented by the avatar. */
  name: string;
  /** The size of the avatar. Prefer a token; pass exact dimensions only for a
   * design the scale has no size for. */
  size?: AvatarSizeType;
};

export const UserAvatar = ({
  name,
  size = 'medium',
  inactive,
  disabled,
  ...props
}: UserAvatarProps) => {
  const { semantic } = useTheme();
  const color = getKeyFromText(getDecorativeSurfaces(semantic.colour), name);
  const initials = useInitials({ name, max: 2, size });

  /** Support the deprecated 'disabled' prop */
  const backwardsCompatibleInactive = inactive || disabled;

  return (
    <Base
      color={color}
      shape="round"
      size={size}
      {...props}
      inactive={backwardsCompatibleInactive}
    >
      {initials}
    </Base>
  );
};
